export const LaunchDestination = ({ targetLabel, isUnlocked }) => (
  <div className="launch-destination" data-testid="energy-core-target-hud" data-state={isUnlocked ? "unlocked" : "locked"}>
    <div className="launch-moon">
      <div className="launch-moon__orb" data-testid="launch-moon-orb">
        <img className="launch-moon__surface" src="/assets/artwork/launch/holographic-moon.webp" alt="" width="320" height="320" decoding="async" aria-hidden="true" />
        <svg className="launch-moon__hud" viewBox="0 0 140 140" aria-hidden="true">
          <circle cx="70" cy="70" r="66" className="launch-moon__ring" pathLength="100" />
          <circle cx="70" cy="70" r="61" className="launch-moon__inner" pathLength="100" />
        </svg>
        <img className="launch-moon__crown" src="/assets/artwork/legendary/gold-crown.webp" alt="" width="136" height="65" decoding="async" aria-hidden="true" data-testid="energy-core-target-crown" />
        <span className="launch-moon__amount" data-testid="energy-core-target-value">{targetLabel}</span>
      </div>
      <span className="launch-moon__label" data-testid="energy-core-target-caption">MAJOR ECOSYSTEM UNLOCK</span>
    </div>
    <div className="launch-beyond" data-testid="launch-deep-space">
      <img className="launch-beyond__space" src="/assets/artwork/launch/deep-space.webp" alt="" width="329" height="177" decoding="async" aria-hidden="true" />
      <span className="launch-beyond__point" data-testid="launch-beyond-point" aria-hidden="true" />
      <span className="launch-beyond__label" data-testid="launch-beyond-label">BEYOND THE MOON <span aria-hidden="true">→</span></span>
    </div>
  </div>
);